import React, {lazy, Suspense, useContext, useEffect, useState} from 'react';
import Chart from 'react-apexcharts';
import ApexCharts from 'react-apexcharts';
import {useTranslation} from 'react-i18next';
import {getFaturacaoAnual} from '../../../../pages/requests';

const FaturacaoAnual = () => {
    const {t} = useTranslation();

    // Loadings
    const [loading, setLoading] = useState(true);

    let lang;
    switch (localStorage.getItem('i18nextLng')) {
        case 'pt':
            lang = 'POR';
            break;
        case 'fr':
            lang = 'FRA';
            break;
        case 'en':
            lang = 'ENG';
            break;
        case 'es':
            lang = 'ES'; 
            break;
    }

    const [state, setState] = useState({
        series: [
            {
                name: '',
                data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                color: '#1A56DB',
            },
            {
                name: '',
                data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                color: '#16BDCA',
            },
        ],
    });

    useEffect(() => {
        setLoading(false);
        var promises = [];
        promises.push(
            getFaturacaoAnual(lang).then(res => {
                if (res.data.success) {
                    const updatedSeries = state.series.map((item, index) => {
                        const fatData = res.data.faturacao[index];
                        return {
                            ...item,
                            name: fatData?.ano,
                            data: fatData?.valores,
                        };
                    });

                    setState({
                        series: updatedSeries,
                    });
                }
            }),
        );

        Promise.all(promises).finally(() => {
            setLoading(false);
        });
    }, []);

    const options = {
        xaxis: {
            categories: [t('jan'), t('fev'), t('mar'), t('abr'), t('maio'), t('jun'), t('jul'), t('ago'), t('set'), t('out'), t('nov'), t('dez')],
            labels: {
                style: {
                    fontFamily: 'Inter, sans-serif',
                    fontSize: '12px',
                    cssClass: 'text-xs font-normal fill-gray-500 dark:fill-gray-400',
                },
            },
        },
        yaxis: {
            labels: {
                style: {
                    fontFamily: 'Inter, sans-serif',
                    fontSize: '12px',
                    cssClass: 'text-xs font-normal fill-gray-500 dark:fill-gray-400',
                },
                formatter: function (value) {
                    return value + '€';
                },
            },
        },

        chart: {
            sparkline: {
                enabled: false,
            },
            height: '320px',
            width: '100%',
            type: 'area',
            fontFamily: 'Inter, sans-serif',
            dropShadow: {
                enabled: false,
            },
            toolbar: {
                show: false,
            },
        },
        tooltip: {
            enabled: true,
            x: {
                show: false,
            },
        },
        fill: {
            type: 'gradient',
            gradient: {
                opacityFrom: 0.55,
                opacityTo: 0,
                shade: '#1C64F2',
                gradientToColors: ['#1C64F2'],
            },
        },
        dataLabels: {
            enabled: false,
        },
        stroke: {
            width: 2,
        },
        legend: {
            show: false,
        },
        grid: {
            show: false,
        },
    };
    useEffect(() => {
        if (document.getElementById('labels-chart')) {
            const chart = new ApexCharts(document.getElementById('labels-chart'), options);
            chart.render();
        }
    }, []);

    return (
        <div className="h-full w-full bg-white rounded-[8px] shadow dark:bg-gray-800">
            <div className="flex justify-between p-4 md:p-6 pb-0 md:pb-0">
                <div>
                    <h5 className="leading-none text-xl font-bold text-gray-900 dark:text-white pb-2">{t('faturacaoAnual')}</h5>
                </div>
                <div className="flex flex-row justify-end">
                    <div className="flex  min-w-47.5 px-4 py-1">
                        <div className="flex   justify-center mr-2 items-center  bg-[#1A56DB] w-5 h-5  rounded-full transition-all duration-300 transform group-hover:rotate-12">
                            <span className="w-12 h-12 p-1 text-blue-800 dark:text-gray-800 transform transition-transform duration-500 ease-in-out" />
                        </div>
                        <div className="w-full">
                            <p className="font-semibold text-[#1A56DB] ">{state.series[0]?.name}</p>
                        </div>
                    </div>
                    <div className="flex  min-w-47.5 px-4 py-1">
                        <div className="flex   justify-center mr-2 items-center  bg-[#16BDCA] w-5 h-5  rounded-full transition-all duration-300 transform group-hover:rotate-12">
                            <span className="w-12 h-12 p-1 text-blue-800 dark:text-gray-800 transform transition-transform duration-500 ease-in-out" />
                        </div>
                        <div className="w-full">
                            <p className="font-semibold text-[#16BDCA] ">{state.series[0]?.name}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div id="labels-chart" className="px-2.5">
                <ApexCharts options={options} series={state.series} type={options.chart.type} height={options.chart.height} />
            </div>
        </div>
    );
};

export default FaturacaoAnual;
